import { api } from '../../lib/api.ts';

export interface OrgUserRow { id: string; email: string; name: string; role: 'SYS_ADMIN' | 'ORG_ADMIN' | 'USER'; isActive: boolean }

export const usersApi = {
  list: () => api.get<{ users: OrgUserRow[] }>('/users').then((r) => r.data),
};
